import Frames from "@fae/source/engine/animating/Frames.js"

export default {
    "frames": Frames.run({
        "tweentime": 80,
        "images": [
            require("./fireanim-embering-0000.png"),
            require("./fireanim-embering-0001.png"),
            require("./fireanim-embering-0002.png"),
            require("./fireanim-embering-0003.png"),
            require("./fireanim-embering-0004.png"),
            require("./fireanim-embering-0005.png"),
            require("./fireanim-embering-0006.png"),
            require("./fireanim-embering-0007.png"),
            require("./fireanim-embering-0008.png"),
            require("./fireanim-embering-0009.png"),
        ]
    })
}
